<template>
	<div>
		<vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

			<vs-button type="flat">
				<font-awesome-icon :icon="['fas', 'ellipsis-h']" class="fa-icon"/>
			</vs-button>


			<vs-dropdown-menu class="vx-navbar-dropdown">
				<ul style="min-width: 20rem">

					<vx-tooltip text="Bekijk alle details van deze bestelling" position="left" delay="0.5s">
						<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
							@click="showDetails">
							<div>
								<font-awesome-icon class="fa-icon" :icon="['far', 'file-alt']"
												   style="font-size: 1.0rem"/>
							</div>
							<span class="ml-2">
                        Details
                    </span>
						</li>
					</vx-tooltip>

					<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
						@click="markDone">
						<div>
							<font-awesome-icon class="fa-icon" :icon="['fas', 'check']" style="font-size: 1.0rem"/>
						</div>
						<span class="ml-2">Markeer als voltooid</span>
					</li>

					<div v-if="!this.order.order.is_bol_vvb_order">
						<vs-divider class="m-1" color="primary">Verzenden</vs-divider>

						<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
							@click="shipOrder">
							<div>
								<font-awesome-icon class="fa-icon" :icon="['fas', 'truck']" style="font-size: 1.0rem"/>
							</div>
							<span class="ml-2">Verzenden</span>
						</li>
					</div>

					<vs-divider class="m-1" color="primary">Labels</vs-divider>

					<div v-for="deliveryOption in this.order.delivery_options">
						<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="downloadVvbLabel(deliveryOption.id)">
							<div>
								<font-awesome-icon class="fa-icon" :icon="['fas', 'file-pdf']" style="font-size: 1.0rem"/>
							</div>
							<span class="ml-2">{{ deliveryOption.label_display_name }} (VVB)</span>
						</li>
					</div>


					<vx-tooltip :text="printShippingToolTipText()" position="left" delay="0.5s">
						<li class="flex py-2 px-4 hover:bg-primary hover:text-white"
							@click="printShippingLabel"
							:class="printShippingButtonDisabled() ? 'cursor-not-allowed' : 'cursor-pointer'">
							<div>
								<font-awesome-icon class="fa-icon" :icon="['fas', 'print']" style="font-size: 1.0rem"/>
							</div>
							<span class="ml-2">Adres label</span>
						</li>
					</vx-tooltip>

					<vx-tooltip text="Print een A6 label met de adres gegevens" position="left" delay="0.5s">
						<li class="flex py-2 px-4 hover:bg-primary hover:text-white cursor-pointer" @click="printShippingLabelA6">
							<div>
								<font-awesome-icon class="fa-icon" :icon="['fas', 'file-pdf']" style="font-size: 1.0rem"/>
							</div>
							<span class="ml-2">Adres label (pdf A6)</span>
						</li>
					</vx-tooltip>

					<vx-tooltip :text="printReturnToolTipText()" position="left" delay="0.5s">
						<li class="flex py-2 px-4 hover:bg-primary hover:text-white"
							@click="printReturnLabel"
							:class="printReturnButtonDisabled() ? 'cursor-not-allowed' : 'cursor-pointer'">
							<div>
								<font-awesome-icon class="fa-icon" :icon="['fas', 'print']" style="font-size: 1.0rem"/>
							</div>
							<span class="ml-2">Retour label</span>
						</li>
					</vx-tooltip>

					<vs-divider class="m-1" color="primary" v-if="this.sendCloudEnabled">Sendcloud</vs-divider>

					<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
						@click="createSendcloudLabel" v-if="this.sendCloudEnabled && !this.order.sendcloud_parcel_id">
						<div>
							<font-awesome-icon class="fa-icon" :icon="['fas', 'print']" style="font-size: 1.0rem"/>
						</div>
						<span class="ml-2">Verzendlabel maken</span>
					</li>

					<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
						@click="downloadSendcloudLabel" v-if="this.sendCloudEnabled && this.order.sendcloud_parcel_id">
						<div>
							<font-awesome-icon class="fa-icon" :icon="['fas', 'file-pdf']" style="font-size: 1.0rem"/>
						</div>
						<span class="ml-2">Verzendlabel downloaden</span>
					</li>

					<vs-divider class="m-1" color="primary">Dropshipping</vs-divider>

					<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
						@click="markDropship">
						<div>
							<font-awesome-icon class="fa-icon" :icon="['fas', 'people-carry']"
											   style="font-size: 1.0rem"/>
						</div>
						<span class="ml-2">Besteld bij dropshipper</span>
					</li>

					<vs-divider v-if="this.moneybirdEnabled || this.eboekhoudenEnabled || this.isModuleInvoiceEnabled" class="m-1" color="primary">
						Facturen verzenden
					</vs-divider>

					<li v-if="this.eboekhoudenEnabled && (!order.eboekhoud || !order.eboekhoud.invoice_send)"
						id="sendEboekhoudInvoice"
						class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
						@click="sendEboekhoudenInvoice">
						<div>
							<font-awesome-icon class="fa-icon" :icon="['fas', 'file-invoice-dollar']"
											   style="font-size: 1.0rem"/>
						</div>
						<span class="ml-2">E-boekhouden</span>
					</li>

					<vx-tooltip v-if="this.eboekhoudenEnabled && order.eboekhoud && order.eboekhoud.invoice_send" text="Factuur is reeds verzonden" position="left">
						<li class="flex py-2 px-4 cursor-pointer hover:bg-success hover:text-white">
							<div>
								<font-awesome-icon class="fa-icon" :icon="['fas', 'file-invoice-dollar']"
												   style="font-size: 1.0rem"/>
							</div>
							<span class="ml-2">E-boekhouden</span>
						</li>
					</vx-tooltip>


					<li v-if="this.moneybirdEnabled && (!order.moneybird || !order.moneybird.invoice_send)"
						class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
						@click="sendMoneybirdInvoice">
						<div>
							<font-awesome-icon class="fa-icon" :icon="['fas', 'file-invoice-dollar']"
											   style="font-size: 1.0rem"/>
						</div>
						<span class="ml-2">Moneybird</span>
					</li>


					<vx-tooltip v-if="this.moneybirdEnabled && order.moneybird && order.moneybird.invoice_send" text="Factuur is reeds verzonden" position="left">
						<li class="flex py-2 px-4 cursor-pointer hover:bg-success hover:text-white">
							<div>
								<font-awesome-icon class="fa-icon" :icon="['fas', 'file-invoice-dollar']"
												   style="font-size: 1.0rem"/>
							</div>
							<span class="ml-2">Moneybird</span>
						</li>
					</vx-tooltip>

					<div id="sendModuleInvoice" v-if="this.isModuleInvoiceEnabled">
						<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="sendModuleInvoice">
							<div>
								<font-awesome-icon class="fa-icon" :icon="['fas', 'file-invoice-dollar']"
												   style="font-size: 1.0rem"/>
							</div>
							<span class="ml-2">Piqwise factuur</span>
						</li>
					</div>


					<vs-divider
						v-if="(this.moneybirdEnabled && order.moneybird && order.moneybird.invoice_made) || (this.eboekhoudenEnabled && order.eboekhoud && order.eboekhoud.invoice_made) || this.isModuleInvoiceEnabled"
						class="m-1" color="primary">
						Facturen downloaden
					</vs-divider>

					<div v-if="this.eboekhoudenEnabled && order.eboekhoud && order.eboekhoud.invoice_made">
						<div id="downloadEboekhoudInvoice">
							<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
								@click="downloadEboekhoudInvoice">
								<div>
									<font-awesome-icon class="fa-icon" :icon="['fas', 'file-invoice-dollar']"
													   style="font-size: 1.0rem"/>
								</div>
								<span class="ml-2">Eboekhouden</span>
							</li>
						</div>
					</div>

					<div v-if="this.moneybirdEnabled && order.moneybird && order.moneybird.invoice_made">
						<div id="downloadMoneybirdInvoice">
							<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
								@click="downloadMoneybirdInvoice">
								<div>
									<font-awesome-icon class="fa-icon" :icon="['fas', 'file-invoice-dollar']"
													   style="font-size: 1.0rem"/>
								</div>
								<span class="ml-2">Moneybird</span>
							</li>
						</div>
					</div>

					<div v-if="this.isModuleInvoiceEnabled">
						<div id="downloadModuleInvoice">
							<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
								@click="downloadModuleInvoice">
								<div>
									<font-awesome-icon class="fa-icon" :icon="['fas', 'file-invoice-dollar']"
													   style="font-size: 1.0rem"/>
								</div>
								<span class="ml-2">Piqwise factuur</span>
							</li>
						</div>
					</div>


					<vs-divider class="m-1" color="primary">Annuleren</vs-divider>

					<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
						@click="cancelOrder">
						<div>
							<font-awesome-icon class="fa-icon" :icon="['fas', 'ban']" style="font-size: 1.0rem"/>
						</div>
						<span class="ml-2">Annuleren</span>
					</li>
				</ul>
			</vs-dropdown-menu>
		</vs-dropdown>

		<ship-order :key="'shiporder-' + this.order.order.id" ref="shipOrderPopup" :order="this.order"/>

		<create-send-cloud :key="'createsendcloud-' + this.order.order.id" ref="createSendCloudPopup" :order="this.order"/>

		<vs-prompt
			@accept="cancelOrderAccept()"
			:active.sync="cancelDialog.visible"
			title="Bestelling Annuleren"
			acceptText="Bevestig"
			color="warning"
			cancelText="Nee, ga terug">
			<form data-vv-scope="cancelForm">
				<div class="vx-row">
					<div class="vx-col h-full w-full">
						<label class="multiselect-label">Selecteer reden</label>
						<vue-multiselect
							v-validate="'required'"
							placeholder="Selecteer een annuleer reden"
							v-model="cancelDialog.cancelReason"
							:options="cancelDialog.options"
							:show-labels="false"
							:allow-empty="false"
							track-by="name" label="name"
						/>
					</div>
				</div>
			</form>
		</vs-prompt>

		<vs-prompt
			@accept="dropshipOrderAccept"
			:active.sync="dropshipDialog.visible"
			title="Bestelling besteld bij dropshipper"
			acceptText="Besteld"
			cancelText="Annuleren">
			<form data-vv-scope="dropshipForm">
				<div class="vx-row">
					<div class="vx-col w-full">
						<vs-input
							v-validate="'required'"
							name="reference"
							label="Bestel referentie"
							:danger-text="errors.first('dropshipForm.reference')"
							:danger="errors.has('dropshipForm.reference')"
							v-model="dropshipDialog.reference"/>
					</div>
				</div>
			</form>
		</vs-prompt>

		<vs-popup :fullscreen="true" :title="`Bestelling overzicht #${order.order.type_id_visible}`" :active.sync="popupVisible">
			<order-details-popup :order="order" v-if="popupVisible" :dymo-printer="dymoPrinter"/>
		</vs-popup>

	</div>
</template>

<script>

import dymoPrinter from '@/services/dymo/dymoPrinter';
import dymoLabels from '@/services/dymo/dymoLabels';
import apiClient from '@/services/apiClient';
import Vue from 'vue';
import VeeValidate from 'vee-validate'
import {Validator} from 'vee-validate';
import ShipOrder from './shipOrder';
import CreateSendCloud from '@/views/orders/order/optionmenu/createSendCloud';
import downloadClient from '@/services/downloadClient';
import {mapGetters} from 'vuex';
import OrderDetailsPopup from '@/views/orderDetails/orderDetailsPopup';
import {format} from "date-fns";

Vue.use(VeeValidate);
const messages = {
	custom: {
		shippingMethod: {
			required: 'Dit veld is verplicht',
		},
		cancelReason: {
			required: 'Dit veld is verplicht',
		},
		reference: {
			required: 'Dit veld is verplicht',
		}
	}
};
Validator.localize('en', messages);

export default {
	components: {
		OrderDetailsPopup,
		CreateSendCloud,
		ShipOrder,
	},
	props: {
		order: {
			type: Object,
			required: true,
		},
		dymoPrinter: {
			type: dymoPrinter,
			required: true
		}
	},
	data() {
		return {
			popupVisible: false,
			cancelDialog: {
				visible: false,
				cancelReason: null,
				options: [
					{
						value: 'OUT_OF_STOCK',
						name: 'Buiten voorraad'
					},
					{
						value: 'REQUESTED_BY_CUSTOMER',
						name: 'Aangevraagd door klant'
					},
					{
						value: 'BAD_CONDITION',
						name: 'Slechte conditie'
					},
					{
						value: 'HIGHER_SHIPCOST',
						name: 'Hogere verzendkosten'
					},
					{
						value: 'INCORRECT_PRICE',
						name: 'Verkeerde prijs'
					},
					{
						value: 'NOT_AVAIL_IN_TIME',
						name: 'Niet op tijd beschikbaar'
					},
					{
						value: 'NO_BOL_GUARANTEE',
						name: 'Geen bol.com garantie'
					},
					{
						value: 'ORDERED_TWICE',
						name: 'Twee keer besteld'
					},
					{
						value: 'RETAIN_ITEM',
						name: 'Items behouden'
					},
					{
						value: 'UNFINDABLE_ITEM',
						name: 'Ontvindbare items'
					},
					{
						value: 'OTHER',
						name: 'Anders'
					},
				],
			},
			dropshipDialog: {
				visible: false,
				reference: ''
			},
		}
	},
	computed: {
		...mapGetters({
			sendCloudEnabled: 'dashboard/sendCloudEnabled',
			moneybirdEnabled: 'dashboard/moneybirdEnabled',
			eboekhoudenEnabled: 'dashboard/eboekhoudenEnabled',
			isModuleInvoiceEnabled: 'dashboard/moduleInvoiceEnabled',
		}),
	},
	methods: {
		showDetails() {
			this.popupVisible = true;
		},
		markDone() {
			this.$vs.dialog({
				type: 'confirm',
				color: 'warning',
				title: 'Markeren als voltooid',
				text: 'Weet je zeker dat je deze bestelling als voltooid wilt markeren?',
				accept: this.markDoneAccept,
				acceptText: 'Ja',
				cancelText: 'Nee'
			});
		},
		markDoneAccept() {
			const params = {
				order_id: this.order.order.id,
				done: true,
			};

			apiClient.put('orders/update', params).then(response => {
				this.$store.dispatch('openOrdersStore/removeOrder', response.data);
			}).catch(error => {
				this.$vs.notify({
					title: 'Oops!',
					text: 'Het markeren als voltooid is mislukt',
					color: 'danger'
				});
			})
		},
		markDropship() {
			this.dropshipDialog.visible = true;
		},
		dropshipOrderAccept() {
			this.$validator.validateAll('dropshipForm').then(result => {
				if (!result) {
					this.dropshipDialog.visible = true;

					this.$vs.notify({
						title: 'Oops!',
						text: 'Er zitten fouten in het formulier.',
						color: 'danger'
					});

					return;
				}

				const params = {
					order_id: this.order.order.id,
					ordered_by_dropshipper: true,
					dropship_reference: this.dropshipDialog.reference,
				};

				apiClient.put('orders/update', params).then(response => {
					this.$store.dispatch('openOrdersStore/removeOrder', response.data);
				}).catch(error => {
					this.$vs.notify({
						title: 'Oops!',
						text: 'Het markeren als dropship van bestelling #' + this.order.order.type_id_visible + ' is mislukt',
						color: 'danger'
					});
				})
			});
		},
		sendEboekhoudenInvoice() {
			this.$vs.loading({
				container: '#sendEboekhoudInvoice',
				scale: 0.60
			})
			if (this.eboekhoudenEnabled) {
				apiClient.post('orders/invoice/send', {
					'order_id': this.order.order.id,
					'type': 'eboekhouden'
				}).then(response => {
					const cloneOrder = JSON.parse(JSON.stringify(this.order));

					cloneOrder.eboekhoud = {
						invoice_send: true
					};

					this.order = cloneOrder;

					this.$vs.loading.close('#sendEboekhoudInvoice > .con-vs-loading')
					this.returnEboekhoudenNotify(200);

				}).catch(error => {
					this.$vs.loading.close('#sendEboekhoudInvoice > .con-vs-loading')
					this.returnEboekhoudenNotify(error.status);
				});
			} else {
				this.$vs.loading.close('#sendEboekhoudInvoice > .con-vs-loading')
				this.returnEboekhoudenNotify(401);
			}
		},
		returnEboekhoudenNotify(errorCode) {
			switch (errorCode) {
				case 200:
					return this.$vs.notify({
						title: 'Gelukt!',
						text: 'Het factuur is succesvol verzonden!',
						color: 'success'
					});
				case 401:
					return this.$vs.notify({
						title: 'e-Boekhouden is niet actief!',
						text: 'Koppel eerst een e-Boekhouden account in de instelling.',
						color: 'danger'
					});
				default:
					return this.$vs.notify({
						title: 'Oops!',
						text: 'Er is iets fout gegaan. Probeer het later nog een keer!',
						color: 'danger'
					});
			}
		},
		downloadEboekhoudInvoice() {
			this.$vs.loading({
				container: '#downloadEboekhoudInvoice',
				scale: 0.45
			})
			if (this.eboekhoudenEnabled) {
				downloadClient.downloadInvoicePdf(this.order.order.id, 'eboekhouden');
				this.$vs.loading.close('#downloadEboekhoudInvoice > .con-vs-loading');
			} else {
				this.$vs.loading.close('#downloadEboekhoudInvoice > .con-vs-loading');
				this.returnEboekhoudenNotify(401);
			}
		},
		downloadMoneybirdInvoice() {
			this.$vs.loading({
				container: '#downloadMoneybirdInvoice',
				scale: 0.45
			})
			if (this.moneybirdEnabled) {
				downloadClient.downloadInvoicePdf(this.order.order.id, 'moneybird')
				this.$vs.loading.close('#downloadMoneybirdInvoice > .con-vs-loading')
			} else {
				this.$vs.loading.close('#downloadMoneybirdInvoice > .con-vs-loading')
				this.returnMoneybirdNotify(401)
			}
		},

		sendMoneybirdInvoice() {
			this.$vs.loading({
				container: '#sendMoneybirdInvoice',
				scale: 0.45
			})
			if (this.moneybirdEnabled) {
				apiClient.post('orders/invoice/send', {
					'order_id': this.order.order.id,
					'type': 'moneybird'
				}).then(response => {
					const cloneOrder = JSON.parse(JSON.stringify(this.order));

					cloneOrder.moneybird = {
						invoice_send: true
					};

					this.order = cloneOrder;

					this.$vs.loading.close('#sendMoneybirdInvoice > .con-vs-loading')

					this.returnMoneybirdNotify(200)
				}).catch(error => {
					this.$vs.loading.close('#sendMoneybirdInvoice > .con-vs-loading')
					this.returnMoneybirdNotify(error.status)
				});
			} else {
				this.$vs.loading.close('#sendMoneybirdInvoice > .con-vs-loading')
				this.returnMoneybirdNotify(401)
			}
		},
		returnMoneybirdNotify(errorCode) {
			switch (errorCode) {
				case 200:
					return this.$vs.notify({
						title: 'Gelukt!',
						text: 'Het factuur is succesvol verzonden!',
						color: 'success'
					});
				case 401:
					return this.$vs.notify({
						title: 'Moneybird is niet actief!',
						text: 'Koppel eerst een moneybird account in de instelling.',
						color: 'danger'
					});
				case 402:
					return this.$vs.notify({
						title: 'Moneybird limiet bereikt!',
						text: 'Je moneybird limiet is bereikt, upgrade je pakket of probeer het later nog een keer.',
						color: 'danger'
					});
				default:
					return this.$vs.notify({
						title: 'Oops!',
						text: 'Er is iets fout gegaan. Probeer het later nog een keer!',
						color: 'danger'
					});
			}
		},

		sendModuleInvoice() {
			this.$vs.loading({
				container: '#sendModuleInvoice',
				scale: 0.45
			})

			const params = {
				'order_id': this.order.order.id,
				'type': 'module_invoice'
			}

			apiClient.post('orders/invoice/send', params).then(response => {
				this.$vs.notify({
					title: 'Gelukt',
					text: 'Factuur is opnieuw naar de klant verzonden.',
					color: 'success'
				});

				this.$vs.loading.close('#sendModuleInvoice > .con-vs-loading')
			}).catch(error => {
				this.$vs.notify({
					title: 'Oops',
					text: 'Het verzenden van de factuur is mislukt.',
					color: 'danger'
				});

				this.$vs.loading.close('#sendModuleInvoice > .con-vs-loading')
			});
		},
		downloadModuleInvoice() {
			this.$vs.loading({
				container: '#downloadModuleInvoice',
				scale: 0.45
			})

			const params = {
				'order_id': this.order.order.id,
				'type': 'module_invoice'
			}

			apiClient.get('orders/invoice/download', {
				params,
				responseType: 'blob'
			}).then(response => {

				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = url;

				link.setAttribute('download', this.order.order.type_id_visible + ' - ' + format(new Date(), 'Y-MM-dd_H:mm:ss') + '.pdf');
				document.body.appendChild(link);
				link.click();

				this.$vs.loading.close('#downloadModuleInvoice > .con-vs-loading')
			}).catch(error => {
				this.$vs.notify({
					title: 'Oops',
					text: 'Het downloaden van de factuur is mislukt.',
					color: 'danger'
				});
				this.$vs.loading.close('#downloadModuleInvoice > .con-vs-loading')
			});
		},

		cancelOrder() {
			this.cancelDialog.visible = true;
		},
		cancelOrderAccept() {
			this.$validator.validateAll('cancelForm').then(result => {
				if (!result) {
					this.cancelDialog.visible = true;

					this.$vs.notify({
						title: 'Oops!',
						text: 'Er zitten fouten in het formulier.',
						color: 'danger'
					});

					return;
				}

				const params = {
					order_id: this.order.order.id,
					cancel: true,
					cancel_reason: this.cancelDialog.cancelReason.value,
				}

				apiClient.put('orders/update', params).then(response => {
					this.$vs.notify({
						title: 'Gelukt!',
						text: 'Bestelling is succesvol geannuleerd!',
						color: 'success'
					})
					this.$store.dispatch('openOrdersStore/removeOrder', response.data);
				}).catch(error => {

					this.$vs.notify({
						title: 'Oops!',
						text: 'Het annuleren van bestelling #' + this.order.order.type_id_visible + ' is mislukt',
						color: 'danger'
					});
				})
			});
		},
		downloadVvbLabel(deliveryOptionId) {
			const params = {
				order_id: this.order.order.id,
				order_bol_delivery_options_id: deliveryOptionId,
			}

			apiClient.put('orders/ship/vvb/select', params).then(response => {
				this.$store.dispatch('openOrdersStore/updateOrder', response.data);

				downloadClient.downloadVvbLabelPdf(this.order.order.id, deliveryOptionId).then(() => {
					const params = {
						order_id: this.order.order.id,
					}

					apiClient.get('orders/get/order', {params}).then(response => {
						this.$store.dispatch('openOrdersStore/updateOrder', response.data);
					});
				});
			}).catch(error => {
				this.$vs.notify({
					title: 'Oops!',
					text: 'Het downloaden van het label is mislukt',
					color: 'danger'
				});

				this.stopLoadingVvbLabel();
			})
		},
		printShippingToolTipText() {
			if (!this.dymoPrinter.shippingPrinterReady()) {
				return 'Er is geen verbinding met de adres label printer';
			}

			return 'Print adres label';
		},
		printShippingButtonDisabled() {
			return !this.dymoPrinter.shippingPrinterReady();
		},
		printShippingLabel() {
			if (!this.dymoPrinter.shippingPrinterReady()) {
				this.$vs.notify({
					title: 'Oops!',
					text: 'Er is geen verbinding met de adres label printer',
					color: 'danger'
				});
			}

			this.dymoPrinter.printShippingLabel(this.order);
		},
		printShippingLabelA6() {
			apiClient.get('orders/a6AddressLabel/download', {
				params: {'order_id': this.order.order.id},
				responseType: 'blob'
			}).then(response => {

				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = url;

				link.setAttribute('download', 'adreslabel-' + format(new Date(), 'Y-MM-dd_H:mm:ss') + '.pdf');
				document.body.appendChild(link);
				link.click();
			}).catch(error => {
				console.log(error);

			})
		},
		printReturnToolTipText() {
			if (!this.dymoPrinter.returnPrinterReady()) {
				return 'Er is geen verbinding met de retour label printer';
			}

			return 'Print retour label';
		},
		printReturnButtonDisabled() {
			return !this.dymoPrinter.returnPrinterReady();
		},
		printReturnLabel() {
			if (!this.dymoPrinter.returnPrinterReady()) {
				this.$vs.notify({
					title: 'Oops!',
					text: 'Er is geen verbinding met de retour label printer',
					color: 'danger'
				});
			}


			this.dymoPrinter.printReturnLabel();
		},
		createSendcloudLabel() {
			this.$refs.createSendCloudPopup.visible = true;
		},
		downloadSendcloudLabel() {
			downloadClient.downloadSendCloudPdf(this.order.sendcloud_parcel_id);
		},
		shipOrder() {
			this.$refs.shipOrderPopup.visible = true;
		}
	}
}
</script>

<style>
li.disabled {
	pointer-events: none;
}

li.disabled:hover {
	cursor: not-allowed;
}
</style>
